import { HotkeyInfo } from '../hotkeys.service'

export enum MODIFIERS {
  ALT = 'Alt',
  OPTION = 'Option',
}

export enum HOTKEY_VIEWS {
  BASIC = 'Basic',
  PAYMENTS = 'Payments',
  SELLING = 'Sell Screen',
}

export const BASIC: HotkeyInfo[] = [
  {
    combo: [MODIFIERS.ALT, '/'],
    summary: 'View this modal',
  },
  {
    combo: ['Esc'],
    summary: 'Back / Exit / Complete Sale',
  },
  {
    combo: ['Tab'],
    summary: 'Focus on next item',
  },
]

export const SELLING: HotkeyInfo[] = [
  {
    combo: [MODIFIERS.ALT, 'S'],
    summary: 'Focus on product search',
  },
  {
    combo: [MODIFIERS.ALT, 'C'],
    summary: 'Focus on customer search',
  },
  {
    combo: [MODIFIERS.ALT, 'L'],
    summary: 'Edit last added item',
  },
  {
    combo: [MODIFIERS.ALT, 'P'],
    summary: 'Pay for sale',
  },
  {
    combo: ['F5'],
    summary: 'Park Sale',
  },
  {
    combo: ['F6'],
    summary: 'Go to Sales History',
  },
  {
    combo: ['F7'],
    summary: 'Open / Close Register',
  },
]

export const PAYMENTS: HotkeyInfo[] = [
  {
    combo: [MODIFIERS.ALT, '1-9'],
    summary: 'Use specific Payment type (1-9)',
  },
]

export const ALL_HOTKEYS = {
  [HOTKEY_VIEWS.BASIC]: BASIC,
  [HOTKEY_VIEWS.SELLING]: SELLING,
  [HOTKEY_VIEWS.PAYMENTS]: PAYMENTS,
}
